import { Link } from 'react-router-dom'
import { Button } from '@square/ui'
import RouteHeader from './RouteHeader'

export default function Forbidden() {
  return (
    <div style={{ maxWidth: 540 }}>
      <RouteHeader
        kicker="403"
        title="Access denied"
        description="You don't have permission to view this resource."
      />
      <Link to="/dashboard">
        <Button variant="secondary">Back to dashboard</Button>
      </Link>
    </div>
  )
}
